// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1tPGi","search":"Settings_search__2tMLY","filter":"Settings_filter__1Njtd"};